import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");

    try {
      const response = await axios.post("  https://rehabwmg.online/api/password/reset", {
        email,
        password,
        password_confirmation: confirmPassword,
        token,
      });

      alert(response.data.message);
      navigate("/login"); // Redirect to login page after successful reset
    } catch (error) {
      alert(error.response?.data?.message || "La réinitialisation du mot de passe a échoué.");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
    <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
      <h2 className="text-center mb-3">Réinitialiser le mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100">Réinitialiser le mot de passe</button>
      </form>
    </div>
  </div>
  );
};

export default ResetPassword;
